import { useTranslation } from "react-i18next";
import imgFileUpload from "../assets/images/img-file-upload.svg";
import { AlertService } from "../utility/service/alert-service";

export function FormInputFile({
  register,
  errors,
  id,
  name,
  rules,
  disabled = false,
  placeholder,
  labelText,
  labelClass = "",
  labelStyle = {},
  wrapperClass = "",
  wrapperStyle = {},
  enterClick,
  onChange,
  onInput,
  style = {},
  fileChange,
  fileInputRef,
  acceptFileType = "image/*",
  limitSize = "5MB",
}) {
  const { t } = useTranslation();

  let errorObj = undefined;

  if (id.split(".").length > 1 && Object.keys(errors).length > 0) {
    let tarErrors = errors;
    let errorObjCheckIdx = 0;
    const idArr = id.split(".");
    // console.log('複雜欄位檢核', idArr)
    idArr.forEach((res, idx) => {
      if (tarErrors[res]) {
        errorObjCheckIdx = idx;
        tarErrors = tarErrors[res];
      }
    });

    if (errorObjCheckIdx === idArr.length - 1) {
      errorObj = tarErrors;
    } else errorObj = undefined;
  }
  if (disabled) {
    return <></>;
  } else {
    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const files = Array.from(e.dataTransfer.files);

      // 過濾符合 accept 的檔案
      const acceptedExtensions = acceptFileType.split(",").map((ext) => ext.trim().toLowerCase());
      const filteredFiles = files.filter((file) => {
        const ext =
          "." +
          file.name
            .split(".")
            .pop()
            .toLowerCase();
        return acceptedExtensions.includes(ext);
      });

      if (filteredFiles.length > 0) {
        const dataTransfer = new DataTransfer();
        filteredFiles.forEach((file) => dataTransfer.items.add(file));
        if (fileInputRef) {
          fileInputRef.current.files = dataTransfer.files;
        }

        fileChange({ target: { files: dataTransfer.files } });
      } else {
        AlertService.ok("Error", `File type is not allowed!`);
      }
    };

    const handleDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    return (
      <>
        {labelText ? (
          <label htmlFor={id} className={`form-label` + ` ${labelClass}`} style={labelStyle}>
            {labelText}
          </label>
        ) : (
          <></>
        )}
        <label className={`custom-input-file ${wrapperClass}`} style={wrapperStyle}>
          {/* <p>點擊方框，以上傳檔案</p> */}
          <div onDrop={handleDrop} onDragOver={handleDragOver}>
            <input
              {...register(id, rules)}
              id={id}
              ref={fileInputRef}
              name={name}
              type="file"
              onChange={fileChange}
              accept={acceptFileType}
            />
            <div className="flex align-items-center justify-content-center lg:gap-2 gap-1 flex-wrap">
              <div className="img-bg">
                <img srcSet={imgFileUpload} />
              </div>
              <div className="custom-input-file-limit w-full text-center">
                <small>
                  {t("acceptFileType")}：{acceptFileType}
                </small>
                <small>
                  {t("limitSize")}：{limitSize}
                </small>
              </div>
            </div>
          </div>
        </label>
      </>
    );
  }
}
